'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _once2 = require('lodash/once');

var _once3 = _interopRequireDefault(_once2);

var _conversationalForm = require('conversational-form');

var _conversationalForm2 = _interopRequireDefault(_conversationalForm);

var _Question = require('./Question');

var _Question2 = _interopRequireDefault(_Question);

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RESERVED_IDS = ['chat', 'chatForm'];
var RESERVED_ERROR = 'Can\'t instantiate a new FormChat with a question/question ID equalling (' + RESERVED_IDS.join(', ') + ').';
var REF_SUFFIX = 'Ref';

/**
 * Check if the IDs for the question props are all valid. They must be unique, and not-reserved
 *
 * @param {string} id
 * @param {Object} state
 *
 * @return {void}
 */
function checkIfIdIsReserved(id, state) {
    if (!id) {
        return;
    }

    if (RESERVED_IDS.includes(id)) {
        throw new Error(RESERVED_ERROR);
    }

    if ((0, _keys2.default)(state).includes(id)) {
        throw new Error('All question IDs must be unique (' + id + ').');
    }
}

/**
 * Throws an error if the child isn't a Question or Select component
 *
 * @param {JSX} child
 */
function checkValidChild(child) {
    if (child.type !== _Question2.default && child.type !== _Select2.default) {
        throw new Error('Conversation children must be either Questions or Selects. Found ' + child.type + '.');
    }
}

/**
 * Returns the ID with the suffix appended
 *
 * @param {string} id
 *
 * @return {string}
 */
function getRefKey(id) {
    return '' + id + REF_SUFFIX;
}

/**
 * Check every el/ref in state has been assigned
 *
 * @param {Object} state
 *
 * @return {boolean}
 */
function allRefsSet(state) {
    return (0, _keys2.default)(state).every(function (stateKey) {
        return !stateKey.includes(REF_SUFFIX) || Boolean(state[stateKey]);
    });
}

/**
 * Builds initial state from children form elements. Makes sure the IDs and element types are
 * valid. Adds props to each form element and stores them in the state.
 *
 * @param {JSX} children
 * @param {func} injectPropsFunc
 *
 * @return {Object}
 */
function getInitialisedState(children, injectPropsFunc) {
    return _react2.default.Children.toArray(children).reduce(function (state, child, index) {
        var _extends2;

        checkValidChild(child);
        checkIfIdIsReserved(child.props.id, state);

        var questionId = child.props.id || 'question' + (index + 1);

        return (0, _extends5.default)({}, state, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, questionId, ''), (0, _defineProperty3.default)(_extends2, getRefKey(questionId), void 0), (0, _defineProperty3.default)(_extends2, 'formElements', [].concat((0, _toConsumableArray3.default)(state.formElements), [injectPropsFunc(child, questionId)])), _extends2));
    }, { chatFormRef: void 0, chat: void 0, formElements: [] });
}

/**
 * Validates the result of a question
 *
 * @param {string} id
 * @param {string} text
 * @param {function|string} validation
 *
 * @return {bool}
 */
function isValidResult(id, text, validation) {
    if (typeof validation === 'string') {
        return new RegExp(validation).test(text);
    }

    if (typeof validation === 'function') {
        return validation(text);
    }

    console.warn('Ignoring validation for question [' + id + '] - type not recognised.');

    return true;
}

var FormChat = function (_Component) {
    (0, _inherits3.default)(FormChat, _Component);

    function FormChat(props) {
        (0, _classCallCheck3.default)(this, FormChat);

        var _this = (0, _possibleConstructorReturn3.default)(this, (FormChat.__proto__ || (0, _getPrototypeOf2.default)(FormChat)).call(this, props));

        _this.setRef = _this.setRef.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.injectPropsToChild = _this.injectPropsToChild.bind(_this);
        _this.startConversation = (0, _once3.default)(_this.startConversation);

        _this.state = getInitialisedState(props.children, _this.injectPropsToChild);
        return _this;
    }

    /**
     * Add props to each form element child
     *
     * @param {JSX} child
     * @param {string} id
     *
     * @return {JSX}
     */


    (0, _createClass3.default)(FormChat, [{
        key: 'injectPropsToChild',
        value: function injectPropsToChild(child, id) {
            return _react2.default.cloneElement(child, { id: id, ref: this.setRef(getRefKey(id)) });
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit() {
            var _this2 = this;

            var _props = this.props,
                onSubmit = _props.onSubmit,
                submittedResponseText = _props.chatOptions.submittedResponseText;
            var formElements = this.state.formElements;


            if (submittedResponseText) {
                _conversationalForm2.default.addRobotChatResponse(submittedResponseText);
            }

            var formValues = formElements.reduce(function (submitValues, question) {
                return (0, _extends5.default)({}, submitValues, (0, _defineProperty3.default)({}, question.props.id, _this2.state[question.props.id]));
            }, {});

            onSubmit(formValues);
        }

        /**
         * Set an element ref in state
         *
         * @param {string} elName
         *
         * @return {void}
         */

    }, {
        key: 'setRef',
        value: function setRef(elName) {
            var _this3 = this;

            var tryToStartConversation = function tryToStartConversation() {
                if (allRefsSet(_this3.state)) {
                    _this3.startConversation();
                }
            };

            return function (el) {
                if (el && !_this3.state[elName]) {
                    _this3.setState((0, _defineProperty3.default)({}, elName, el), tryToStartConversation);
                }
            };
        }

        /**
         * Try and start the form chat. If all refs haven't been set, then do nothing. Set questions from
         * props and configure form chat.
         *
         * @return {void}
         */

    }, {
        key: 'startConversation',
        value: function startConversation() {
            var _this4 = this;

            var _props$chatOptions = this.props.chatOptions,
                robotResponseTime = _props$chatOptions.robotResponseTime,
                robotChainResponseTime = _props$chatOptions.robotChainResponseTime,
                showUserThinking = _props$chatOptions.showUserThinking,
                thankTheUser = _props$chatOptions.thankTheUser,
                introText = _props$chatOptions.introText;
            var _state = this.state,
                formElements = _state.formElements,
                chatFormRef = _state.chatFormRef;


            formElements.forEach(function (questionEl, index) {
                var _questionEl$props = questionEl.props,
                    id = _questionEl$props.id,
                    children = _questionEl$props.children,
                    question = _questionEl$props.question;

                var displayThanks = thankTheUser && thankTheUser.includes(id) ? 'Thanks.&&' : '';
                var questionPrefix = index === 0 && introText ? introText + '&&' : displayThanks;
                var questionText = '' + questionPrefix + (question || children);

                _this4.state[getRefKey(id)].state.el.setAttribute('cf-questions', questionText);
            });

            this.setState({
                chat: _conversationalForm2.default.startTheConversation({
                    formEl: chatFormRef,
                    userInterfaceOptions: {
                        robot: {
                            robotResponseTime: robotResponseTime || 250,
                            chainedResponseTime: robotChainResponseTime || 1500
                        },
                        user: { showThinking: showUserThinking || false }
                    },
                    context: document.getElementById('cf-context'),
                    flowStepCallback: function flowStepCallback(_ref, success, error) {
                        var id = _ref.tag.id,
                            text = _ref.text;

                        // Set the result of the input in state
                        _this4.setState((0, _defineProperty3.default)({}, id, text));

                        var validation = _this4.state[getRefKey(id)].props.validation;

                        if (!validation) {
                            return success();
                        }

                        return isValidResult(id, text, validation) ? success() : error();
                    },
                    submitCallback: this.onSubmit
                })
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var formElements = this.state.formElements;


            return _react2.default.createElement(
                'div',
                { className: 'form-chat', style: { height: '100%' } },
                _react2.default.createElement(
                    'div',
                    { id: 'cf-context', style: { height: '100%' } },
                    _react2.default.createElement(
                        'form',
                        { id: 'form', className: 'form', ref: this.setRef('chatFormRef') },
                        formElements
                    )
                )
            );
        }
    }]);
    return FormChat;
}(_react.Component);

exports.default = FormChat;


FormChat.propTypes = {
    onSubmit: _propTypes2.default.func.isRequired,
    children: _propTypes2.default.node,
    chatOptions: _propTypes2.default.shape({
        robotResponseTime: _propTypes2.default.number,
        robotChainResponseTime: _propTypes2.default.number,
        showUserThinking: _propTypes2.default.bool,
        thankTheUser: _propTypes2.default.arrayOf(_propTypes2.default.string),
        introText: _propTypes2.default.string,
        submittedResponseText: _propTypes2.default.string
    })
};

FormChat.defaultProps = {
    chatOptions: {},
    children: void 0
};


//////////////////
// WEBPACK FOOTER
// ./~/react-conversation-form/dist/Conversation.js
// module id = 730
// module chunks = 0